import { useRef } from 'react';

export default function useAutoResize() {
  const messagesContainer = useRef(null);
  const scrollPosition = useRef(0);

  const handleMessageInputResize = (prevHeight, currentHeight) => {
    const currentScrollPosition = scrollPosition.current;
    const offset = currentHeight - prevHeight;
    messagesContainer.current.scrollTop = currentScrollPosition + offset;
    scrollPosition.current = currentScrollPosition + offset;
  };

  const memorizeScrollPosition = () => {
    scrollPosition.current = messagesContainer.current.scrollTop;
  };

  const updateScrollPosition = () => {
    const offset = messagesContainer.current.scrollHeight
      - messagesContainer.current.clientHeight;
    messagesContainer.current.scrollTop = offset;
    scrollPosition.current = offset;
  };

  return {
    messagesContainer,
    scrollPosition,
    handleMessageInputResize,
    memorizeScrollPosition,
    updateScrollPosition,
  };
}
